<!-- <app-context-menu title="Time to think" (back)="INDRA_handleBack()">
	<div class="actions">
		<app-booking-options></app-booking-options>
	</div>
	<div class="steps container space-between">
		<div>
			<h1 class="title-h1">{{ 'timeToThink.text.tripSummary' | ibeadmin | async }}</h1>
		</div>
		<app-shopping-cart></app-shopping-cart>
	</div>
</app-context-menu> -->

<app-steps-footer (confirmTTTPayment)="INDRA_handleSelect()"></app-steps-footer>

<section *ngIf="!isLoading">
	<app-background-world-animation *ngIf="!isMobile" [showPlane]="this.booked_trip.flights.length === 1">
	</app-background-world-animation>

	<div class="container">
		<p>{{ 'timeToThink.text.notSureYouCanFly' | ibeadmin | async }}</p>
		<h2 class="title-h2 title-h2--page">{{ 'timeToThink.text.saveTodaysPrice' | ibeadmin | async }} {{timeToThink.validity}} 
			<ng-container *ngIf="!showInDays; else inDays">{{ 'timeToThink.text.hoursForOnly' | ibeadmin | async }}</ng-container>
			<ng-template #inDays>{{ 'timeToThink.text.daysForOnly' | ibeadmin | async }}</ng-template>
			 {{timeToThink.totalFee + currency | indracurrency }}</h2>
    </div>

	<div class="grid" *ngIf="!isLoading && !loadingExtras">
		<ng-container *ngFor="let ticket of INDRA_getFlightTickets(); trackBy: trackById; let listIndex = index">
				
            <app-extras-flight *ngIf="ticket.type === 'flight'" id="{{ ticket.id }}" 
                [flight]="ticket.item"
                [flight_extras]="ticket.item.extras"
                [loading_extras]="loadingExtras"
                [booked_trip]="bookedTrip"
                [ngClass]="['col-6 col-tl-6 col-p-12 col-tp-12']"
				[upgradeInfo]="false"
				[editOrChangeInfo]="false">
                <!-- (setExtraFeatures)="INDRA_getExtraFeatures($event, listIndex)"> -->
            </app-extras-flight>
            
            <!-- <app-ticket-stopover *ngIf="ticket.type === 'stopover'" 
                (addFeature)="INDRA_addFeature($event)"
                id="{{ ticket.id }}" 
                [stopover]="ticket.item" 
                [ngClass]="['col-6 col-tl-6 col-p-12 col-tp-12']">
            </app-ticket-stopover> -->
            
        </ng-container>
	</div>
</section>

<section class="container" *ngIf="!isLoading">
	<div class="payment-table">
		<div class="payment-table__line" role="listitem">
			<div class="payment-table__cell">{{ 'timeToThink.text.passengers' | ibeadmin | async }}</div>
			<div class="payment-table__cell">
				<span>{{this.passengers.adults}}</span> {{this.passengers.adults === 1 ? ('timeToThink.text.adult' | ibeadmin | async) : ('timeToThink.text.adults' | ibeadmin | async)}}
				<span *ngIf="this.passengers.youngAdults>0">, <span>{{this.passengers.youngAdults}}</span> 
				{{this.passengers.youngAdults === 1 ? ('timeToThink.text.youngAdult' | ibeadmin | async) : ('timeToThink.text.youngAdults' | ibeadmin | async) }}</span>
				<span *ngIf="this.passengers.children>0">, <span>{{this.passengers.children}}</span>
					{{this.passengers.children === 1 ? ('timeToThink.text.child' | ibeadmin | async) : ('timeToThink.text.children' | ibeadmin | async)}}</span>
				<span *ngIf="this.passengers.infants>0">, <span>{{this.passengers.infants}}</span>
					{{this.passengers.infants === 1 ? ('timeToThink.text.infant' | ibeadmin | async) : ('timeToThink.text.infants' | ibeadmin | async)}}</span>
			</div>
		</div>
		<div class="payment-table__line" role="listitem">
			<div class="payment-table__cell">{{ 'timeToThink.text.tickets' | ibeadmin | async }}</div>
			<div class="payment-table__cell" *ngIf="flightPrice">
				<span class="line-through" *ngIf="flightPrice.discounted">
					{{ flightPrice.oldTotalFlightCost | indracurrency }}
				</span>
				{{ flightPrice.totalFlightCost | indracurrency }}
			</div>
		</div>
	</div>

	<div class="align-right">
		<a (click)="INDRA_handlePriceBreakDown()" class="link display--block top-gap" href="javascript:;" role="button">
			{{ 'timeToThink.text.priceBreakdown' | ibeadmin | async }}
		</a>
	</div>

	<div class="ttt_total-amount-summary__wrapper">
		<h3 class="title-h3 title-confirmation">{{ 'timeToThink.text.totalToPayNow' | ibeadmin | async }}</h3>
		<span class="ttt_total-price-description">{{ 'timeToThink.text.timeToThink' | ibeadmin | async }}</span>
		<span class="ttt_total-price title-h3">{{timeToThink.totalFee + currency | indracurrency}}</span>
	</div>
</section>

<div class="divider"></div>

<section class="container align-right action-buttons" *ngIf="!isLoading">
	<a (click)="INDRA_handleBack()" 
		class="link" href="javascript:;" 
		[attr.aria-label]="'timeToThink.aria.resetAndChooseOther' | ibeadmin | async"
		role="button">
		{{ 'timeToThink.text.returnToFlights' | ibeadmin | async }}
	</a>
	<!-- <button [attr.aria-label]="'timeToThink.aria.continueToPayment' | ibeadmin | async" class="button button-accent button--icon-right" (click)="INDRA_handleSelect()">
		{{ 'timeToThink.text.continue' | ibeadmin | async }}
		<app-svg svg="icons.svg#general--arrow--right" [alt]="'Arrow right icon'" aria-hidden="true"></app-svg>
	</button> -->
</section>

<app-loading *ngIf="isLoading"></app-loading>
